import React from "react";

/**
 * Get a function that wil force a component to re-render.
 */
export const useForceRender = () => {
  const [, setCount] = React.useState(0);
  return React.useCallback(() => {
    setCount(count => (count + 1) % 1000000);
  }, []);
};